import Image from 'next/image';

export const TwoKOLogo = ({ size = 96 }: { size?: number }) => {
  return (
    <div
      style={{ width: size, height: size }}
      className="relative"
    >
      <Image
        src="/2XKO_LOGO_192.png"
        fill
        alt="2XKO"
        className="object-contain"
        sizes={`${size}px`}
      />
    </div>
  );
};
